import { Box } from "@mantine/core";

import { connect, useDispatch } from "react-redux";
import { Route, Routes, useLocation } from "react-router-dom";
import { showNotification } from "@mantine/notifications";
import { useEffect } from "react";

import { logger } from "utils/logger";

import {
  batchUpdateWipAssetSuccess,
  clearNotifications,
  selectStyles,
  setSessionCapturesSuccess,
  setWipFilter,
} from "./wipSlice";
import Wips from "./features/wips/Wips";
import Style from "./features/style/Style";
import ItemNotFound from "core/components/itemNotFound/ItemNotFound";
import Production from "./features/production/Production";
import PostProduction from "./features/postProduction/PostProduction";

const WipsModule = ({
  user,
  guide,
  guides,
  selectedSamples,
  success,
  error,
  setSampleFilter,
  guideFilter,
  selectSamples,
  setGuideFilter,
}) => {
  const dispatch = useDispatch();

  // SUCCESS AND ERROR HANDLERS
  useEffect(() => {
    logger.log(success);
    if (error) {
      showNotification({
        title: "Whoops something went wrong.",
        message: error.message,
        position: "top-center",
        color: "red",
      });

      dispatch(clearNotifications());
    }

    if (success) {
      switch (success.type) {
        case setSessionCapturesSuccess.toString(): 
        case batchUpdateWipAssetSuccess.toString(): {
          showNotification({
            title: "Success",
            message: success.message,
            position: "top-center",
            color: "teal",
          });

          dispatch(clearNotifications());

          break;
        }
        // case getScheduleSuccess.toString(): {
        //   dispatch(clearNotifications());
        //   break;
        // }
        default: {
          break;
        }
      }
    }

    // if the session has been created then we load the session detail view
  }, [error, success, dispatch, clearNotifications]);

  const location = useLocation();

  useEffect(() => {
    // Attempt to restore scroll position when route changes
    const scrollPosition = sessionStorage.getItem(location.pathname);

    if (scrollPosition) {
      window.scrollTo(0, parseInt(scrollPosition, 10));
    } else {
      window.scrollTo(0, 0);
    }

    // Save scroll position before navigating away
    const handleScroll = () => {
      sessionStorage.setItem(location.pathname, window.scrollY.toString());
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname]);

  return (
    <Box
      id="wipModule"
      className="module-container"
      // style={(theme) => ({
      //     backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.white,
      //     width: '100%',
      //     height: '100%',
      // })}
    >
      <Routes>
        <Route path="/studio" element={<Wips />}></Route>
        <Route path="/approval/production" element={<Production />}></Route>
        <Route path="/approval/production/:sessionId/:styleNumber" element={<Style />}></Route>
        <Route path="/approval/postproduction" element={<PostProduction />}></Route>
        <Route path="/:id" element={<ItemNotFound description="No information available for WIP Styles" />}></Route>
        {/* <Route path="/:id" element={<Style />}></Route> */}
      </Routes>
    </Box>
  );
};

const mapStateToProps = (state, props) => {
  //logger.log(state,props, ' mapstate')
  return {
    user: state.auth.user,
    wipFilter: state.wipReducer.wipFilter,
    selectedStyles: state.wipReducer.selectedStyles,
    wip: state.wipReducer.selectedWip,
    // guides: state.guideReducer.guides,
    success: state.wipReducer.success,
    displayPrefs: state.wipReducer.displayPrefs,
    error: state.wipReducer.error,
  };
};

const mapDispatchToProps = { setWipFilter, selectStyles };

export default connect(mapStateToProps, mapDispatchToProps)(WipsModule);
